<!-- App.vue -->
<template>
  <div id="app" class="app-container" >
    <!--数字雨背景-->
    <jje-background></jje-background>
    <div class="content-wrapper">
      <jje-header></jje-header>
      <router-view></router-view>
      <jje-footer></jje-footer>
    </div>
  </div>
</template>

<script>
import JjeHeader from '@/components/JjeHeader/index'
import JjeFooter from "@/components/JjeFooter/index";
import JjeBackground from "@/components/JjeBackground/index";
export default {
  name: 'App',
  components: {
    JjeFooter,
    JjeHeader,
    JjeBackground
  },
};

</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 0px;
}
/* 设置全局样式 */
.app-container {
  width: 100%; /* 设定最大宽度，根据需要调整 */
  padding: 0;
  /*background: #EEEEEE;*/
  margin: 0;
}
/* 内容包装器 */
.content-wrapper {
  max-width: 1000px; /* 设定最大宽度，根据需要调整 */
  margin: 0 auto; /* 自动左右边距使得内容居中 */
  margin-top: 35px;
  padding: 0 0px; /* 为小屏幕设备添加一些内边距 */
}

/* 对于移动设备的响应式设计 */
@media (max-width: 768px) {
}
</style>
